<div class="content-wrapper">
  <div class="content-header">
    <app-content-header [contentHeader]="contentHeader"></app-content-header>
  </div>
  <div class="content-body">
    <section class="form-control-repeater">
      <div class="row">
        <div class="col-12">
          <div class="card">
            <div class="card-header">
              <h4 class="card-title">اسناد الفعالية</h4>
            </div>
            <div class="card-body">
              <!-- Event Details Section -->
              <div class="event-details-container" *ngIf="eventData">
                <div class="row">
                  <!-- Event Cover Photo -->
                  <div class="col-md-4">
                    <div class="event-image-container">
                      <img [src]="eventData.coverPhoto" alt="Event Cover" class="img-fluid rounded event-cover">
                      <!-- <img [src]="eventData.headPhoto" alt="Event Head" class="img-fluid rounded event-head mt-2"> -->
                    </div>
                  </div>
                  
                  <!-- Event Information -->
                  <div class="col-md-4">
                    <div class="event-info">
                      <h3 class="text-primary">{{eventData.nameAr}}</h3>
                      <h5 class="text-muted">{{eventData.nameEn}}</h5>
                      
                      <div class="event-meta mt-3">
                        <div class="meta-item">
                          <i data-feather="calendar" class="mr-50"></i>
                          <span>تاريخ الإنشاء: {{eventData.createdOn | date:'mediumDate'}}</span>
                        </div>
                        <div class="meta-item">
                          <i data-feather="map" class="mr-50"></i>
                          <span>المكان: {{eventData.place}}, {{eventData.country}}</span>
                        </div>
                        <div class="meta-item">
                          <i data-feather="credit-card" class="mr-50"></i>
                          <span>السعر الأدنى: {{eventData.minPrice | currency:'SAR':'symbol':'1.2-2'}}</span>
                        </div>
                      </div>
                      
                    </div>
                  </div>

                  <div class="col-md-4">
                    <div class="event-info">
                        
                      <div class="event-description mt-1">
                        <h6 class="text-info">الوصف:</h6>
                        <p>{{eventData.description}}</p>
                      </div>
                      
                      <div class="event-policy mt-2">
                        <h6 class="text-info">السياسات:</h6>
                        <p>{{eventData.policy}}</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
  
              <!-- Assign Organizer Section (Space for additional functionality) -->
              <div class="assign-organizer-section mt-2" *ngIf="eventData">
                <h5 class="section-title">تعيين مشرف للفعالية</h5>
                <div class="section-content p-1 bg-light rounded">
                  <!-- This space is reserved for the organizer assignment form/functionality -->
                  <!-- <p class="text-muted">سيتم إضافة نموذج تعيين المشرف هنا</p> -->
                    <ul ngbNav #nav="ngbNav" class="nav nav-pills">
                        <li ngbNavItem>
                            <a ngbNavLink>المشرفون المعينون</a>
                            <ng-template ngbNavContent>
                                <!-- <div class="responsive-table">
                                    <table class="table table-bordered table-striped">
                                        <thead>
                                            <tr>
                                                <th>المشرف</th>
                                                <th>الفعالية</th>
                                                <th>حذف</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr>
                                                <td>مشرف 1</td>
                                                <td>{{eventData.nameAr || eventData.nameEn }}</td> 
                                                <td>
                                                    <div class="d-flex align-items-center">
                                                        <button class="btn btn-sm btn-danger" (click)="assignOrganizerToEvent(organizer.id)">
                                                            <i data-feather="trash-2" class="mr-50"></i>
                                                            حذف
                                                        </button>
                                                    </div>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>مشرف 2</td>
                                                <td>{{eventData.nameAr || eventData.nameEn }}</td> 
                                                <td>
                                                    <div class="d-flex align-items-center">
                                                        <button class="btn btn-sm btn-danger" (click)="assignOrganizerToEvent(organizer.id)">
                                                            <i data-feather="trash-2" class="mr-50"></i>
                                                            حذف
                                                        </button>
                                                    </div>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div> -->
                                <div class="d-flex mb-3" style="align-items: center;justify-content: space-between;">
                                    <div class="input-group input-group-merge w-auto">
                                        <input type="text" id="first-name-icon" class="form-control" name="fname-icon" placeholder="ابحث فى المشرفين المعينين" (keyup)="updateFilter($event)">
                                        <span class="input-group-text">
                                            <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <circle cx="10" cy="10.5867" r="7" stroke="#2F2B3D" stroke-opacity="0.9" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                                <path d="M21 21.5867L15 15.5867" stroke="#2F2B3D" stroke-opacity="0.9" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                            </svg>
                                        </span>
                                    </div>
                                    <div class="d-flex">
                                        <select id="per-page" class="form-control pl-3 pr-0" (change)="onLimitChange($event.target.value)">
                                            <option *ngFor="let option of pageLimitOptions" [value]="option.value" [selected]="option.value == currentPageLimit">
                                            {{ option.value }}
                                            </option>
                                        </select>
                                    </div>
                                </div>
                                <ngx-datatable
                                    #table
                                    id="ngxTable"
                                    class="material bootstrap core-bootstrap"
                                    [rows]="assignedOrganizers"
                                    [columnMode]="'force'"
                                    [headerHeight]="40"
                                    [footerHeight]="50"
                                    [limit]="10"
                                    [rowHeight]="'auto'"
                                    [scrollbarH]="true"
                                    [selectAllRowsOnPage]="true"
                                >
                                    <ngx-datatable-column name="#" prop="#" [width]="10"></ngx-datatable-column>
                                    <ngx-datatable-column prop="name" name="اسم المشرف" [width]="50"></ngx-datatable-column>
                                    <ngx-datatable-column prop="eventName" name="اسم الفاعلية" [width]="50"></ngx-datatable-column>
                                    
                                    <ngx-datatable-column name="" [width]="30" [sortable]="false">
                                        <ng-template ngx-datatable-cell-template let-row="row">
                                            <div class="d-flex align-items-center">
                                                <a href="javascript:void(0)" class="d-flex align-items-center btn btn-danger" (click)="removeOrganizer(row.id)" type="button"> 
                                                    <i data-feather="trash-2" class="mr-50"></i> حذف
                                                </a>
                                            </div>
                                        </ng-template>
                                    </ngx-datatable-column>
                                </ngx-datatable>
                            </ng-template>
                        </li>
                        <li ngbNavItem>
                            <a ngbNavLink>تعيين مشرف</a>
                            <ng-template ngbNavContent>
                                <!-- <div class="responsive-table">
                                    <table class="table table-bordered table-striped">
                                        <thead>
                                            <tr>
                                                <th>المشرف</th>
                                                <th>حذف</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr>
                                                <td>مشرف 1</td>
                                                <td>
                                                    <div class="d-flex align-items-center">
                                                        <button class="btn btn-sm btn-primary" (click)="assignOrganizerToEvent(organizer.id)">
                                                            <i data-feather="plus" class="mr-50"></i>
                                                            إضافة
                                                        </button>
                                                    </div>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>مشرف 2</td>
                                                <td>
                                                    <div class="d-flex align-items-center">
                                                        <button class="btn btn-sm btn-primary" (click)="assignOrganizerToEvent(organizer.id)">
                                                            <i data-feather="plus" class="mr-50"></i>
                                                            إضافة
                                                        </button>
                                                    </div>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div> -->
                                <div class="d-flex mb-3" style="align-items: center;justify-content: space-between;">
                                        <div class="input-group input-group-merge w-auto">
                                            <input type="text" id="first-name-icon" class="form-control" name="fname-icon" placeholder="ابحث فى المشرفين" (keyup)="updateFilter2($event)">
                                            <span class="input-group-text">
                                                <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <circle cx="10" cy="10.5867" r="7" stroke="#2F2B3D" stroke-opacity="0.9" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                                    <path d="M21 21.5867L15 15.5867" stroke="#2F2B3D" stroke-opacity="0.9" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                                </svg>
                                            </span>
                                        </div>
                                        <div class="d-flex">
                                            <select id="per-page" class="form-control pl-3 pr-0" (change)="onLimitChange2($event.target.value)">
                                                <option *ngFor="let option of pageLimitOptions" [value]="option.value" [selected]="option.value == currentPageLimit">
                                                {{ option.value }}
                                                </option>
                                            </select>
                                        </div>
                                    </div>
                                    <ngx-datatable
                                        #table2
                                        id="ngxTable"
                                        class="material bootstrap core-bootstrap"
                                        [rows]="assignNewOrganizers"
                                        [columnMode]="'force'"
                                        [headerHeight]="40"
                                        [footerHeight]="50"
                                        [limit]="10"
                                        [rowHeight]="'auto'"
                                        [scrollbarH]="true"
                                        [selectAllRowsOnPage]="true"
                                    >
                                        <ngx-datatable-column name="#" prop="#" [width]="10"></ngx-datatable-column>
                                        <ngx-datatable-column prop="orgName" name="اسم المشرف" [width]="50"></ngx-datatable-column>
                                        
                                        <ngx-datatable-column name="" [width]="30" [sortable]="false">
                                            <ng-template ngx-datatable-cell-template let-row="row">
                                                <div class="d-flex align-items-center">
                                                    <a href="javascript:void(0)" class="d-flex align-items-center btn btn-primary" (click)="addOrganizer(row.id)" type="button"> <!--(click)="deleteItem(row.id);modalOpenDefault(modalDelete)" -->
                                                        <i data-feather="plus-circle" class="mr-50"></i> إضافة
                                                    </a>
                                                </div>
                                            </ng-template>
                                        </ngx-datatable-column>
                                    </ngx-datatable>
                            </ng-template>
                        </li>
                    </ul>
                    <div [ngbNavOutlet]="nav" class="mt-1"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</div>

<ngb-toast 
  *ngIf="toastService.message" 
  [autohide]="true" 
  (hidden)="toastService.clear()"
  style="position: fixed;left: 30px;top: 95px;"
  delay="5000"
>
  <span style="color: #3F8260;">{{ toastService.message }} </span>
</ngb-toast>